import {
  ENTITY_NAME_TO_PREFIX,
  EntityName
} from "@/services/api/entityPrefixes";
import { EntityType } from "@/components/ui/entity-type";

// Re-exported so existing importers keep working; the enum lives beside the design-system component that reads it.
export { EntityType } from "@/components/ui/entity-type";

type EntityTypeToEntityName = {
  [key in EntityType]: string;
};

type EntityToPrefixMap = {
  [key in EntityType]: string;
};

type EntityToPageFieldNameMap = Partial<Record<EntityType, string>>;

export const entityTypeToFieldName: EntityToPageFieldNameMap = {
  [EntityType.DEAL]: "dealId",
  [EntityType.PERSON]: "contactId",
  [EntityType.COMPANY]: "companyId",
  [EntityType.LEAD]: "leadId",
  [EntityType.CONTRACT]: "contractId"
};

export const entityTypeToEntityName: EntityTypeToEntityName = {
  [EntityType.DEAL]: "deals",
  [EntityType.PERSON]: "people",
  [EntityType.COMPANY]: "companies",
  [EntityType.USER]: "users",
  [EntityType.LEAD]: "leads",
  [EntityType.CONTRACT]: "contracts",
  [EntityType.PARTNER]: "partners",
  [EntityType.PARTNER_CONTACT]: "partners_contacts"
};

export const entityTypeToSingleEntityName: EntityTypeToEntityName = {
  [EntityType.DEAL]: "deal",
  [EntityType.PERSON]: "person",
  [EntityType.COMPANY]: "company",
  [EntityType.USER]: "user",
  [EntityType.LEAD]: "lead",
  [EntityType.CONTRACT]: "contract",
  [EntityType.PARTNER]: "partner",
  [EntityType.PARTNER_CONTACT]: "partner contact"
};

export const entityTypeToPrefix: EntityToPrefixMap = Object.entries(
  entityTypeToEntityName
).reduce((map, [key, name]) => {
  const prefix = ENTITY_NAME_TO_PREFIX[name as EntityName];
  if (prefix === undefined) {
    throw new Error(`Missing prefix for entity name: ${name}`);
  }
  map[Number(key) as EntityType] = prefix;
  return map;
}, {} as EntityToPrefixMap);

export const prefixToEntityType: Record<string, EntityType> = Object.entries(
  entityTypeToPrefix
).reduce<Record<string, EntityType>>((map, [entityType, prefix]) => {
  map[prefix] = Number(entityType) as EntityType;
  return map;
}, {});
